var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 20,
    width: 16,
    height: 2,
    rx: 1,
    fill: "black",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30293 10.7839C6.66845 10.4286 7.23602 10.4088 7.62398 10.7193L7.71701 10.8038L11.055 14.2379L11.0556 4.00093C11.0556 3.44864 11.5033 3.00093 12.0556 3.00093C12.5684 3.00093 12.9911 3.38697 13.0488 3.88431L13.0556 4.00093L13.055 14.2379L16.3941 10.8038C16.7495 10.4383 17.3163 10.4026 17.7128 10.7021L17.8082 10.7839C18.1737 11.1393 18.2094 11.7061 17.91 12.1026L17.8281 12.198L12.7726 17.398C12.7322 17.4389 12.6913 17.4746 12.6485 17.5062L12.5626 17.5631L12.4518 17.6194L12.3801 17.6471L12.2854 17.6744L12.215 17.6882L12.1142 17.6992L11.9969 17.6992L11.8771 17.685L11.7938 17.6663L11.6848 17.6299L11.6317 17.607L11.5435 17.5601L11.4335 17.484L11.3764 17.4349L11.3386 17.398L6.28301 12.198C5.89802 11.802 5.90694 11.1689 6.30293 10.7839Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDisabled);
export default __webpack_public_path__ + "static/media/download-disabled.340c31cc60b6c883f5fdb612e708e3f1.svg";
export { ForwardRef as ReactComponent };